<template>
  <ul class="nav nav-md flex-column fs-14">
    <li v-for="a in modelList" :key="a.name" class="nav-item treeMenu">
      <b-form-radio
        :class="['ms-1', successNode.includes(a.id) && 'hilight']"
        v-model="selecteds"
        @change="selectedsDetail(a)"
        @mouseenter="handlerHover($event, a)"
        @mouseleave="handlerHover($event, a)"
        name="some-radios"
        :value="a.subId"
      >
        <a
          :href="`${'#' + a.subId}`"
          data-bs-toggle="collapse"
          role="button"
          aria-expanded="false"
          :aria-controls="a.subId"
          :data-key="a.name"
          :style="{
            marginLeft: a.children ? a.num + 'rem' : '1rem',
            fontWeight: '400',
            fontSize: '14px',
            display: 'flex',
            position: 'relative',
            width: 210 - (a.num - 1) * 20 + 'px',
            height: '100%',
          }"
          class="text-dark"
          @click="changeType(a)"
        >
          <div>
            <i style="margin-left: 20px"></i>
            <i
              v-if="a.children && a.children.length != 0"
              :class="[
                'fs-12',
                a.iconType ? ' bx bxs-down-arrow' : 'bx bxs-right-arrow',
              ]"
              style="color: #212529; position: absolute; top: 3px; left: 5px"
            ></i>
          </div>

          <div class="d-flex flex-1">
            <div
              :style="{
                width: 110 - (a.num - 1 * 10) + 'px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }"
            >
              {{ a.name }}
            </div>
          </div>
        </a>
        <div
          :class="['icon-btn', (!a.flag || a.flag == '0') && 'hidden']"
          @click.stop="handlerClickIcon($event, a)"
        >
          <img
            src="@/assets/images/icon-qizhi-click.svg"
            alt=""
            v-if="a.flag == '1'"
          />
          <img src="@/assets/images/icon-qizhi-hover.svg" alt="" v-else />
        </div>
      </b-form-radio>

      <div :class="['collapse', 'show']" :id="a.subId">
        <TreeMenu
          :num="num"
          :selected="selected"
          :successNode="successNode"
          :modelList="a.children"
          @getDetailId="selectedsDetail"
          @getDetail="handlerClick"
        ></TreeMenu>
      </div>
    </li>
  </ul>
</template>

<script>
import TreeMenu from "./treeMenu";
import { editInstanceFlag, editModelFlag } from "@/service/index";
export default {
  emits: ["getDetailId", "getDetail"],
  components: {
    TreeMenu,
  },
  props: {
    successNode: {
      type: Array,
      default: () => [],
    },
    modelList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    selected: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      num: 1,
    };
  },
  computed: {
    selecteds() {
      return this.selected;
    },
  },
  methods: {
    handlerClick() {
      this.$emit("getDetail");
      // if (this.$route.path.includes("asset")) {
      // } else {
      //   this.$emit("getDetailId");
      // }
    },
    handlerHover(event, data) {
      if (!data.flag || data.flag == "0") {
        if (event.type == "mouseenter") {
          if (event.target.getElementsByClassName("icon-btn").length != 0)
            event.target
              .getElementsByClassName("icon-btn")[0]
              .classList.remove("hidden");
        } else {
          if (event.target.getElementsByClassName("icon-btn").length != 0)
            event.target
              .getElementsByClassName("icon-btn")[0]
              .classList.add("hidden");
        }
      }
    },
    handlerClickIcon(event, data) {
      event.stopPropagation();
      event.preventDefault();
      let params = {
        flag: data.flag == "1" ? "0" : "1",
      };
      if (this.$route.path.includes("asset")) {
        editInstanceFlag(data.id, params)
          .then((res) => {
            if (res && res.payload) {
              this.handlerClick();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        editModelFlag(data.id, params)
          .then((res) => {
            if (res && res.payload) {
              this.handlerClick();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    changeType(item) {
      item["iconType"] = !item["iconType"];
    },
    selectedsDetail(item) {
      if (this.$route.path.includes("/asset")) {
        this.$router.push("/asset?asset_id=" + item.id);
      }
      this.$emit("getDetailId", item);
    },
  },
  mounted() {
    var pp = document.getElementsByClassName("form-check-input");
    for (var i = 0; i < pp.length; i++) {
      pp[i].removeAttribute("id");
    }
    this.modelList.map((item) => {
      item["iconType"] = false;
      if (
        document.getElementById(item.subId) &&
        document.getElementById(item.subId).className.indexOf("show") > -1
      ) {
        item["iconType"] = true;
      }
    });
  },
};
</script>

<style lang="scss">
.treeMenu {
  .form-check {
    border-bottom: 1px #e9ebec solid;
    margin: 0;
    display: flex;
    padding: 5px 0 5px 1.6rem;
    &.hilight {
      background: rgba(102, 145, 231, 0.15);
    }
  }
  .icon-btn {
    position: absolute;
    top: 50%;
    right: 5px;
    transform: translateY(-50%);
    &.hidden {
      display: none;
    }
  }
}
</style>
